import PropTypes from 'prop-types';
import { memo } from 'react';
// -*- mode: jsx;-*-

let GiveWidgetToggle = function (props) {
    return (
        <div className="checkbox-holder standalone-checkbox-holder desktop js-click-first-child-on-enter" tabIndex="0">
            <input className="batch-funding toggle-switch" name="batch-funding" id="batch-funding" type="checkbox"
                onChange={props.toggle} checked={props.on} tabIndex="0"/>
            <label htmlFor="batch-funding">Show give box</label>
        </div>
    );
};
GiveWidgetToggle.propTypes = {
    toggle: PropTypes.func.isRequired,
    on: PropTypes.bool,
};
GiveWidgetToggle = memo(GiveWidgetToggle);
export default GiveWidgetToggle;
